import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { decodeReturnTo } from "../utils/listNavigation";

/** Resolve back link from `returnTo` query param (set when leaving a list). */
export function useBackToList(fallbackPath) {
  const [searchParams] = useSearchParams();
  return useMemo(
    () => decodeReturnTo(searchParams.get("returnTo"), fallbackPath),
    [searchParams, fallbackPath]
  );
}
